// Code generated by pbe. DO NOT EDIT.
import { Value as values__Value } from '../values/values.pbe';
import { NewFields, ProtoMessage } from '../../runtime';
export var ORMRefAction = /*#__PURE__*/function (ORMRefAction) {
  ORMRefAction[ORMRefAction["UNSET"] = 0] = "UNSET";
  ORMRefAction[ORMRefAction["RESTRICT"] = 1] = "RESTRICT";
  ORMRefAction[ORMRefAction["CASCADE"] = 2] = "CASCADE";
  ORMRefAction[ORMRefAction["SET_NULL"] = 3] = "SET_NULL";
  return ORMRefAction;
}(ORMRefAction || {});
export class ORMConfig extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ORMConfig());
  }
}
ORMConfig._fqn = 'orm.ORMConfig';
ORMConfig._fields = NewFields([[1, {
  name: 'host',
  json: 'host',
  type: 9
}], [2, {
  name: 'port',
  json: 'port',
  type: 13
}], [3, {
  name: 'username',
  json: 'username',
  type: 9
}], [4, {
  name: 'password',
  json: 'password',
  type: 9
}], [5, {
  name: 'database',
  json: 'database',
  type: 9
}], [6, {
  name: 'charset',
  json: 'charset',
  type: 9
}], [7, {
  name: 'maxIdleConns',
  json: 'max_idle_conns',
  type: 13
}], [8, {
  name: 'maxOpenConns',
  json: 'max_open_conns',
  type: 13
}]]);
export class ORMField extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ORMField());
  }
}
ORMField._fqn = 'orm.ORMField';
ORMField._fields = NewFields([[1, {
  name: 'name',
  json: 'name',
  type: 9
}], [2, {
  name: 'primaryKey',
  json: 'primary_key',
  type: 8
}], [3, {
  name: 'primaryKeyNoIncrement',
  json: 'primary_key_no_increment',
  type: 8
}], [4, {
  name: 'autoIncrement',
  json: 'auto_increment',
  type: 8
}], [5, {
  name: 'index',
  json: 'index',
  type: 8
}], [6, {
  name: 'unique',
  json: 'unique',
  type: 8
}], [7, {
  name: 'null_',
  json: 'null',
  type: 8
}], [8, {
  name: 'maxLength',
  json: 'max_length',
  type: 13
}], [9, {
  name: 'characterSet',
  json: 'character_set',
  type: 9
}], [10, {
  name: 'collation',
  json: 'collation',
  type: 9
}], [11, {
  name: 'default_',
  json: 'default',
  type: 11,
  ctor: () => values__Value
}], [20, {
  name: 'relatedName',
  json: 'related_name',
  type: 9
}], [21, {
  name: 'referenceColumn',
  json: 'reference_column',
  type: 9
}], [22, {
  name: 'o2O',
  json: 'o2o',
  type: 8
}], [23, {
  name: 'm2M',
  json: 'm2m',
  type: 8
}], [24, {
  name: 'through',
  json: 'through',
  type: 9
}], [25, {
  name: 'onDelete',
  json: 'on_delete',
  type: 14
}], [26, {
  name: 'onUpdate',
  json: 'on_update',
  type: 14
}], [40, {
  name: 'date',
  json: 'date',
  type: 8
}], [41, {
  name: 'encrypted',
  json: 'encrypted',
  type: 8
}], [42, {
  name: 'enumAsInt',
  json: 'enum_as_int',
  type: 8
}], [43, {
  name: 'autoNowAdd',
  json: 'auto_now_add',
  type: 8
}], [44, {
  name: 'autoNowUpdate',
  json: 'auto_now_update',
  type: 8
}], [45, {
  name: 'hashed',
  json: 'hashed',
  type: 8
}], [100, {
  name: 'pyName',
  json: 'py_name',
  type: 9
}], [101, {
  name: 'blank',
  json: 'blank',
  type: 8
}], [102, {
  name: 'kwargs',
  json: 'kwargs',
  type: 9
}], [103, {
  name: 'pySkip',
  json: 'py_skip',
  type: 8
}], [104, {
  name: 'djangoType',
  json: 'django_type',
  type: 9
}], [768, {
  name: 'fqn',
  json: 'fqn',
  type: 9
}], [769, {
  name: 'isFk',
  json: 'is_fk',
  type: 8
}], [770, {
  name: 'generated',
  json: 'generated',
  type: 8
}], [771, {
  name: 'isEnum',
  json: 'is_enum',
  type: 8
}], [772, {
  name: 'isRepeated',
  json: 'is_repeated',
  type: 8
}], [1024, {
  name: 'msg',
  json: 'msg',
  type: 11,
  ctor: () => ORMMessage
}], [1025, {
  name: 'protoFieldName',
  json: 'proto_field_name',
  type: 9
}], [1026, {
  name: 'protoName',
  json: 'proto_name',
  type: 9
}], [1027, {
  name: 'goName',
  json: 'go_name',
  type: 9
}], [1028, {
  name: 'type',
  json: 'type',
  type: 9
}], [1029, {
  name: 'typeFqn',
  json: 'type_fqn',
  type: 9
}], [1030, {
  name: 'reverseField',
  json: 'reverse_field',
  type: 11,
  ctor: () => ORMField
}], [1031, {
  name: 'refField',
  json: 'ref_field',
  type: 11,
  ctor: () => ORMField
}]]);
export class ORMFile extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ORMFile());
  }
}
ORMFile._fqn = 'orm.ORMFile';
ORMFile._fields = NewFields([[1, {
  name: 'pySource',
  json: 'py_source',
  type: 9,
  repeated: true
}], [2, {
  name: 'pyPath',
  json: 'py_path',
  type: 9
}]]);
export class ORMMessage extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ORMMessage());
  }
}
ORMMessage._fqn = 'orm.ORMMessage';
ORMMessage._fields = NewFields([[1, {
  name: 'name',
  json: 'name',
  type: 9
}], [2, {
  name: 'characterSet',
  json: 'character_set',
  type: 9
}], [3, {
  name: 'collation',
  json: 'collation',
  type: 9
}], [200, {
  name: 'meta',
  json: 'meta',
  type: 11,
  ctor: () => ORMMeta
}], [768, {
  name: 'fqn',
  json: 'fqn',
  type: 9
}], [769, {
  name: 'protoPackage',
  json: 'proto_package',
  type: 9
}], [770, {
  name: 'generated',
  json: 'generated',
  type: 8
}], [1024, {
  name: 'fields',
  json: 'fields',
  type: 11,
  repeated: true,
  ctor: () => ORMField
}], [1025, {
  name: 'primaryKey',
  json: 'primary_key',
  type: 11,
  ctor: () => ORMField
}], [1026, {
  name: 'autoIncrement',
  json: 'auto_increment',
  type: 11,
  ctor: () => ORMField
}], [1027, {
  name: 'gorm',
  json: 'gorm',
  type: 8
}]]);
export class ORMMeta extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ORMMeta());
  }
}
ORMMeta._fqn = 'orm.ORMMeta';
ORMMeta._fields = NewFields([[1, {
  name: 'dbTable',
  json: 'db_table',
  type: 9
}], [2, {
  name: 'abstract_',
  json: 'abstract',
  type: 8
}], [3, {
  name: 'managed',
  json: 'managed',
  type: 8
}]]);
